import type { IMultiColumnProps } from './MultiColumns'
import type { IMultiColumnsItemProps } from './MultiColumnsItem'

import { styled } from '@linaria/react'
import { ButtonGroupWrapper } from 'blocks/ButtonGroup'
import { FIXED_INDENTS, MEDIA } from 'vars/index'
import {
  MultiColumnsAlignItems,
  MultiColumnsJustifyContent,
  MultiColumnsRowGap,
} from './MultiColumns.h'

export const MultiColumnsItemStyled = styled.div<IMultiColumnsItemProps>`
  ${MEDIA.MIN_1240} {
    align-items: ${({ alignItems }) =>
      alignItems || MultiColumnsAlignItems.FlexStart};
    justify-content: ${({ justifyContent }) =>
      justifyContent || MultiColumnsJustifyContent.FlexStart};
  }
  display: flex;
  flex-direction: ${({ direction }) => `${direction}`};
  row-gap: ${({ rowGap }) => `var(${rowGap || MultiColumnsRowGap.INDENT_0})`};
  align-items: flex-start;
  justify-content: flex-start;
`

export const MultiColumnsStyled = styled.div<IMultiColumnProps>`
  ${MEDIA.MIN_1240} {
    width: ${({ width }) => (width ? `${width}%` : 'auto')};
    -webkit-column-count: ${({ columnValue }) =>
      columnValue ? `${columnValue}` : '2'};
    flex-wrap: nowrap;
  }
  position: relative;
  display: flex;
  flex-wrap: wrap;
  width: ${({ containerWidth }) =>
    containerWidth ? `var(${containerWidth})` : '100%'};
  height: ${({ height }) => (height ? `${height}px` : 'auto')};
  max-width: 100%;
  align-items: ${({ alignItems }) =>
    alignItems || MultiColumnsAlignItems.FlexStart};
  justify-content: ${({ justifyContent }) =>
    justifyContent || MultiColumnsJustifyContent.FlexStart};
  column-gap: ${({ columnValue, columnGap }) =>
    columnValue && columnGap
      ? `var(${columnGap})`
      : columnValue
        ? `${100 / columnValue / 5}%`
        : `var(${columnGap})`};
  -webkit-column-count: 1;
  padding: ${({ paddings }) =>
    typeof paddings === 'object'
      ? paddings?.length
        ? paddings.map((padding) => `var(${padding})`).join(' ')
        : 0
      : `var(${paddings})`};

  &:empty {
    display: none;
  }

  & > :last-child {
    padding-top: var(${FIXED_INDENTS.INDENT_40});
  }

  ${MEDIA.MIN_1240} {
    & > :last-child {
      padding-top: 0;
    }
  }

  & > :first-child {
    padding-top: 0;
  }

  ${MultiColumnsItemStyled} {
    ${MEDIA.MIN_1240} {
      width: ${({ columnValue }) =>
        columnValue
          ? `${(100 - (20 / columnValue) * (columnValue - 1)) / columnValue}%` // this is a formula for calculating the same column width depending on the desired number of columns
          : 'auto'};
    }
    width: 100%;

    /*TODO: affects templates with ButtonGroup as child component, remove from here and add to template where it needs */
    & ${ButtonGroupWrapper} {
      padding-top: var(${FIXED_INDENTS.INDENT_60});
    }
  }
`
